<template>
  <router-view/>
</template>

<script>
export default {
  name:  'host',
  data() {
    return {

    }
  }, 
}
</script>

<style scoped lang="scss">
</style>
